import { PlansService } from 'src/app/data/repository/plans-repository/plans.service';
import { PlanShared } from './../general/shared/plan-shared';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { BottomsheetShared } from '../general/shared/bottomsheet-shared';
import { CalendarShared } from '../general/shared/calendar-shared';
import { MainShared } from '../general/shared/main-shared';
import { LoadingShared } from '../general/shared/loading-shared';
import { BlogShared } from '../general/shared/blog-shared';
import { TabBarShared } from '../general/shared/tab-bar-shared';
import { IosBottomsheetInputModel } from '../general/ios-bottomsheet/ios-bottomsheet.component';
import { ProfileShared } from '../general/shared/profile-shared';
import { TutorialInputModel } from 'src/app/core/model/input/tutorial-input-model';
import { TutorialShared } from '../general/shared/tutorial-shared';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { ReportBottomsheetModel } from '../general/report-bottomsheet/report-bottomsheet.component';
import { RecipeShared } from '../general/shared/recipe-shared';
import { ActivatedRoute } from '@angular/router';
import { LocationStrategyService } from 'src/app/data/repository/navigation-repository/location-strategy.service';
import { PromotionpopupService } from './promotionpopup/promotionpopup.service';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, OnDestroy {
  bottomsheetInput: string;
  currentTab = 1;
  showWeightBottomsheet = false;
  showCalendar = false;
  showTabBar = true;
  showIosBottomsheet = false;
  iosBottomsheetInput: IosBottomsheetInputModel;
  tutorialInput: TutorialInputModel;
  showTutorial = false;

  showLoading = false;

  showBlogNotification = false;
  showPostReport = false;

  bottomsheetData: ReportBottomsheetModel;

  promotionPopup = false;

  planBottomSheet: boolean = false;
  showplanBottomSheet: boolean = false;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;
  subscription6: Subscription;
  subscription7: Subscription;
  subscription8: Subscription;
  subscription9: Subscription;
  subscription10: Subscription;
  subscription11: Subscription;
  subscription12: Subscription;
  subscription13: Subscription;
  subscription14: Subscription;
  subscription15: Subscription;
  subscription16: Subscription;
  subscription17: Subscription;
  subscription18: Subscription;
  subscription19: Subscription;
  subscription20: Subscription;
  subscription21: Subscription;
  subscription22: Subscription;
  subscription23: Subscription;

  constructor(
    private route: ActivatedRoute,
    private bottomsheetShared: BottomsheetShared,
    private calendarShared: CalendarShared,
    private mainShared: MainShared,
    private loadingShared: LoadingShared,
    private blogShared: BlogShared,
    private tabBarShared: TabBarShared,
    private profileShared: ProfileShared,
    private tutorialShared: TutorialShared,
    private diaryAnalytics: DiaryAnalyticsService,
    private recipeShared: RecipeShared,
    private planShared: PlanShared,
    private locationStrategyService: LocationStrategyService,
    private promotionpopupService: PromotionpopupService,
    private plansService: PlansService
  ) {
    this.locationStrategyService.preventBackButton();

    this.subscription1 = this.bottomsheetShared.openBottomsheetObs$.subscribe(
      (open) => {
        if (open) {
          this.bottomsheetInput = this.bottomsheetShared.bottomsheetType;
          this.showWeightBottomsheet = true;
        }
      }
    );
    this.subscription2 = this.bottomsheetShared.closeBottomsheetObs$.subscribe(
      (close) => {
        if (close) {
          this.showWeightBottomsheet = false;
        }
      }
    );
    this.subscription3 =
      this.bottomsheetShared.closeAndUpdateBottomsheetObs$.subscribe(
        (close) => {
          if (close) {
            this.showWeightBottomsheet = false;
          }
        }
      );
    this.subscription4 = this.calendarShared.openCalendarObs$.subscribe(
      (open) => {
        if (open) {
          this.showCalendar = true;
        }
      }
    );
    this.subscription5 = this.calendarShared.closeCalendarObs$.subscribe(
      (close) => {
        if (close) {
          this.showCalendar = false;
        }
      }
    );
    this.subscription6 = this.loadingShared.showLoadingObs$.subscribe(
      (show) => {
        if (show) {
          setTimeout(() => {
            this.showLoading = true;
          }, 0);
        }
      }
    );
    this.subscription7 = this.loadingShared.hideLoadingObs$.subscribe(
      (hide) => {
        if (hide) {
          setTimeout(() => {
            this.showLoading = false;
          }, 0);
        }
      }
    );
    this.subscription8 = this.tabBarShared.showTabBarObs$.subscribe((show) => {
      if (show) {
        this.showTabBar = true;
      }
    });
    this.subscription9 = this.tabBarShared.hideTabBarObs$.subscribe((hide) => {
      if (hide) {
        this.showTabBar = false;
      }
    });
    this.subscription10 =
      this.bottomsheetShared.openFirstIosBottomsheetObs$.subscribe((open) => {
        if (open) {
          this.openFirstIosBottomsheet();
        }
      });
    this.subscription11 =
      this.bottomsheetShared.openSecondIosBottomsheetObs$.subscribe((open) => {
        if (open) {
          this.openSecondIosBottomsheet();
        }
      });
    this.subscription12 =
      this.bottomsheetShared.closeIosBottomsheetObs$.subscribe((close) => {
        if (close) {
          this.showIosBottomsheet = false;
        }
      });
    this.subscription13 = this.tutorialShared.showTutorialObs$.subscribe(
      (show) => {
        if (!localStorage.getItem('show-promotion')) {
          if (show && this.tutorialShared.selectedTutorial) {
            this.tutorialInput = this.tutorialShared.selectedTutorial;
            this.showTutorial = true;
          }
        }
      }
    );
    this.subscription14 = this.tutorialShared.hideTutorialObs$.subscribe(
      (hide) => {
        if (hide) {
          this.showTutorial = false;
        }
      }
    );
    this.subscription15 = this.blogShared.showBlogNotificationObs$.subscribe(
      (show) => {
        if (show) {
          this.showBlogNotification = true;
        }
      }
    );
    this.subscription16 = this.blogShared.hideBlogNotificationObs$.subscribe(
      (hide) => {
        if (hide) {
          this.showBlogNotification = false;
        }
      }
    );
    this.subscription17 = this.mainShared.openReportBottomsheetObs$.subscribe(
      (open) => {
        if (open) {
          this.showPostReportBottomsheet(this.mainShared.getReportPostId());
        }
      }
    );
    this.subscription18 =
      this.bottomsheetShared.closeReportBottomsheetObs$.subscribe((close) => {
        if (close) {
          this.closePostReportBottomsheet();
        }
      });
    this.subscription19 = this.mainShared.secondTabPlansObs$.subscribe(
      (show) => {
        if (show) {
          this.selectTab(2);
          setTimeout(() => {
            this.planShared.showFirstTab();
          }, 10);
        }
      }
    );
    this.subscription20 = this.mainShared.secondTabMyPlanObs$.subscribe(
      (show) => {
        if (show) {
          this.selectTab(2);
          setTimeout(() => {
            this.planShared.showSecondTab();
          }, 10);
        }
      }
    );
    this.subscription21 = this.promotionpopupService.closePromotion$.subscribe(
      (close) => {
        if (close) {
          this.promotionPopup = false;
        }
      }
    );
    this.subscription22 = this.plansService.closeBottomSheet$.subscribe(
      (close) => {
        if (close) {
          this.showplanBottomSheet = false;
          setTimeout(() => {
            this.planBottomSheet = false;
          }, 300);
        }
      }
    );
    this.subscription23 = this.plansService.openBottomSheet$.subscribe(
      (close) => {
        if (close) {
          this.planBottomSheet = true;
          setTimeout(() => {
            this.showplanBottomSheet = true;
          }, 300);
        }
      }
    );
    if (localStorage.getItem('show-promotion')) {
      localStorage.removeItem('show-promotion');
      this.promotionPopup = true;
    }
  }

  ngOnInit() {
    setTimeout(() => {
      if (
        this.route.snapshot.paramMap.get('tabName') &&
        !this.mainShared.currentTab
      ) {
        if (this.route.snapshot.paramMap.get('tabName') === 'diet') {
          this.planShared.isDeeplink = true;
          this.mainShared.currentTab = 1;
        } else if (this.route.snapshot.paramMap.get('tabName') === 'plan') {
          this.mainShared.currentTab = 2;
          setTimeout(() => {
            this.planShared.showSecondTab();
          }, 100);
        } else if (
          this.route.snapshot.paramMap.get('tabName') === 'cookingbook'
        ) {
          this.mainShared.currentTab = 3;
        } else if (this.route.snapshot.paramMap.get('tabName') === 'tribune') {
          this.mainShared.currentTab = 5;
        } else if (
          this.route.snapshot.paramMap.get('tabName') === 'dashboard'
        ) {
          this.mainShared.currentTab = 4;
        }
      }
      if (this.mainShared.currentTab) {
        this.selectTab(this.mainShared.currentTab);
      }
    }, 0);
    // this.blogShared.blogTabSelected();
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    this.subscription5.unsubscribe();
    this.subscription6.unsubscribe();
    this.subscription7.unsubscribe();
    this.subscription8.unsubscribe();
    this.subscription9.unsubscribe();
    this.subscription10.unsubscribe();
    this.subscription11.unsubscribe();
    this.subscription12.unsubscribe();
    this.subscription13.unsubscribe();
    this.subscription14.unsubscribe();
    this.subscription15.unsubscribe();
    this.subscription16.unsubscribe();
    this.subscription17.unsubscribe();
    this.subscription18.unsubscribe();
    this.subscription19.unsubscribe();
    this.subscription20.unsubscribe();
    this.subscription21.unsubscribe();
    this.subscription22.unsubscribe();
    this.subscription23.unsubscribe();
    this.locationStrategyService.unsubscribe();
  }

  selectTab(tabNumber: number) {
    this.currentTab = tabNumber;
    this.mainShared.currentTab = tabNumber;
    this.animateChangeTab();
    if (tabNumber === 1) {
      this.diaryAnalytics.analyticDiaryVisited();
    }
    if (tabNumber === 2) {
    }
    if (tabNumber === 3) {
      this.recipeShared.recipeTabSelected();
    }
    if (tabNumber === 4) {
      this.profileShared.profileTabSelected();
    }
    if (tabNumber === 5) {
      this.blogShared.blogTabSelected();
    }
  }

  animateChangeTab() {
    switch (this.currentTab) {
      case 1: {
        document.getElementById('tab1').style.right = '0';
        document.getElementById('tab2').style.right = '100%';
        document.getElementById('tab3').style.right = '200%';
        document.getElementById('tab4').style.right = '300%';
        document.getElementById('tab5').style.right = '400%';
        break;
      }
      case 2: {
        document.getElementById('tab1').style.right = '-100%';
        document.getElementById('tab2').style.right = '0';
        document.getElementById('tab3').style.right = '100%';
        document.getElementById('tab4').style.right = '200%';
        document.getElementById('tab5').style.right = '300%';
        break;
      }
      case 3: {
        document.getElementById('tab1').style.right = '-200%';
        document.getElementById('tab2').style.right = '-100%';
        document.getElementById('tab3').style.right = '0';
        document.getElementById('tab4').style.right = '100%';
        document.getElementById('tab5').style.right = '200%';
        break;
      }
      case 4: {
        document.getElementById('tab1').style.right = '-300%';
        document.getElementById('tab2').style.right = '-200%';
        document.getElementById('tab3').style.right = '-100%';
        document.getElementById('tab4').style.right = '0';
        document.getElementById('tab5').style.right = '100%';
        break;
      }
      case 5: {
        document.getElementById('tab1').style.right = '-400%';
        document.getElementById('tab2').style.right = '-300%';
        document.getElementById('tab3').style.right = '-200%';
        document.getElementById('tab4').style.right = '-100%';
        document.getElementById('tab5').style.right = '0';
        break;
      }
    }
  }

  openFirstIosBottomsheet() {
    this.iosBottomsheetInput = new IosBottomsheetInputModel(
      ['شروع برنامه غذایی جدید'],
      'لغو'
    );
    this.showIosBottomsheet = true;
  }

  openSecondIosBottomsheet() {
    this.iosBottomsheetInput = new IosBottomsheetInputModel(
      ['ادامه'],
      'انصراف',
      'در صورت ادامه، برنامه فعلی حذف میشود و برنامه غذایی جدید دریافت میکنید.'
    );
    this.showIosBottomsheet = true;
  }

  showPostReportBottomsheet(postId: string) {
    const titles = ['محتوای پست غیراخلاقیه.', 'محتوای پست اشتباهه.'];
    this.bottomsheetData = new ReportBottomsheetModel(
      'post',
      'گزارش',
      'علت گزارش این پست رو انتخاب کنید.',
      titles,
      postId,
      ''
    );
    this.showPostReport = true;
  }

  closePostReportBottomsheet() {
    this.showPostReport = false;
  }
}
